import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  key: 0,
  class: "col-auto d-desktop-inline-block align-self-center"
}
const _hoisted_4 = ["innerHTML", "title"]
const _hoisted_5 = ["innerHTML", "title"]
const _hoisted_6 = { class: "col-auto d-desktop-inline-block" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Kundencenter ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Suche ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Warenkorb ", -1)

import {
  reactive,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  computed,
  nextTick,
  ref,
  watch,
} from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { env } from '@/helpers';
import PartnerInterface from '@/interfaces/PartnerInterface';
import IoSearchForm from '@/components/IoSearchForm.vue';
import MenuInterface from '@/interfaces/MenuInterface';
import HeaderMain from '@/components/BaseHeader/BaseHeaderMain.vue';
import BaseFixedAside from '@/components/aside/BaseFixedAside.vue';
import CartWidget from '@/components/CartWidget.vue';
import HeaderTop from '@/components/BaseHeader/BaseHeaderTop.vue';
import IconCart from '@/components/IconCart.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleUser,
  faSearch,
  faBars,
} from '@fortawesome/pro-light-svg-icons';
import ScrollTopButton from '@/components/ScrollTopButton.vue';
import PageBanner from '@/components/PageBanner.vue';
import MobileNavigation from '@/components/MobileNavigation.vue';
import IoSidebar from '@/components/IoSidebar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeader',
  setup(__props) {

library.add(faCircleUser, faSearch, faBars);
const store = useStore();
const logoSrc = window.ioappConfig.logo;
const partner = computed<PartnerInterface>(() => store.getters['partner/current']);
const partnerActive = computed(() => store.getters['partner/active']);
const logoBar = ref();
const navBar = ref();
const isMobile = ref(false);
const isDesktop = computed(() => !isMobile.value);
const { customerPortalUrl } = window.ioappConfig;

const header = reactive({
  top: 0,
  $el: null as null | HTMLElement,
});

const headerHeight = ref<number>(0);
const wpAdminBarHeight = ref<number>(0);
const setHeaderPos = () => {
  header.top = 0;

  nextTick(() => {
    const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;

    wpAdminBarHeight.value = 0;

    if ($wpAdminBar) {
      wpAdminBarHeight.value += $wpAdminBar.offsetHeight;
    }

    header.top = wpAdminBarHeight.value;

    if (header.$el) {
      headerHeight.value = header.$el.offsetHeight + wpAdminBarHeight.value;
    }
  });
};
const minAmountToScroll = ref(0);
const scrollTop = ref(0);
const hideHeader = ref(false);

const setHeaderTop = () => {
  minAmountToScroll.value = 0;
  if (header.$el) {
    minAmountToScroll.value += header.$el.offsetHeight;
  }

  const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
  if ($wpAdminBar) {
    minAmountToScroll.value += $wpAdminBar.offsetHeight;
  }

  if (window.scrollY > minAmountToScroll.value && window.scrollY > scrollTop.value) {
    hideHeader.value = true;
    store.dispatch('search/close');
    store.dispatch('sidebar/close');
  } else {
    hideHeader.value = false;
  }

  scrollTop.value = window.scrollY;
};

const setHeaderCssVars = () => {
  const $body = document.querySelector('body');
  if (!$body) return;

  let minTransformedHeight = 0;
  const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
  if ($wpAdminBar) {
    minTransformedHeight += $wpAdminBar.offsetHeight;
  }

  $body.style.setProperty('--app-header-height', `${headerHeight.value}px`);
  $body.style.setProperty('--app-header-height-transformed', `${hideHeader.value ? minTransformedHeight : headerHeight.value}px`);
};

watch(() => `${hideHeader.value}:${headerHeight.value}:${wpAdminBarHeight.value}`, () => {
  nextTick(setHeaderCssVars);
}, {
  deep: true,
  immediate: true,
});

const root = ref<HTMLElement>();
const checkIfMobile = () => {
  if (!root.value) return;
  if (!navBar.value) return;
  if (!logoBar.value) return;

  const cloneToCheck = root.value?.cloneNode(true) as HTMLElement;
  if (!cloneToCheck) return;

  const cloneNavBar = cloneToCheck.querySelector('.navbar-nav') as HTMLElement;
  const cloneLogoBar = cloneToCheck.querySelector('.brand-row') as HTMLElement;
  const cloneNavBarParent = cloneNavBar.parentElement as HTMLElement;

  if (!cloneNavBar) return;
  if (!cloneLogoBar) return;
  if (!cloneNavBarParent) return;

  cloneToCheck.id = 'header-clone';
  cloneToCheck.style.opacity = '0';
  cloneToCheck.style.pointerEvents = 'none';
  cloneToCheck.classList.add('desktop');
  cloneToCheck.classList.remove('mobil');

  cloneNavBar.style.position = 'absolute';
  cloneLogoBar.style.position = 'absolute';

  root.value.parentNode?.insertBefore(cloneToCheck, root.value);

  const parentStyle = window.getComputedStyle(cloneNavBarParent);
  const maxWidth = cloneNavBarParent.offsetWidth
      - parseFloat(parentStyle.paddingLeft)
      - parseFloat(parentStyle.paddingRight);
  const navBarWidth = cloneNavBar.offsetWidth;
  const logoBarWidth = cloneLogoBar.offsetWidth;

  isMobile.value = (navBarWidth + logoBarWidth) > maxWidth;

  cloneToCheck.remove();
};

const route = useRoute();
const currentUrl = computed(() => new URL(route.fullPath, window.location.origin).href);
const menuItemsStore = computed(() => store.getters['menus/menu']('header'));
const menuItems = ref<MenuInterface[]>([]);
const menuItemsTop = ref<MenuInterface[]>([]);
const menuItemsMain = ref<MenuInterface[]>([]);
const menuDepth = ref<number>(0);
const menuDepthCheck = ref<number>(0);

const isMenuItemRecursive = (menuItem: MenuInterface, depth = 1): MenuInterface => {
  const updatedMenuItem = { ...menuItem };

  updatedMenuItem.active = updatedMenuItem.url === currentUrl.value;

  if (Array.isArray(updatedMenuItem.children)) {
    updatedMenuItem.children = updatedMenuItem.children.map((item: MenuInterface) => isMenuItemRecursive(item, depth + 1));

    updatedMenuItem.active = updatedMenuItem.active || !!(updatedMenuItem.children || []).find((m: MenuInterface) => m.active);
  }

  if (depth > menuDepthCheck.value) {
    menuDepthCheck.value = depth;
  }

  return updatedMenuItem;
};

const updateMenuItemActiveByStartOfUrl = (items: MenuInterface[]): MenuInterface[] => {
  const updatedItems = [...items];

  let alreadyHasFoundActive = false;
  updatedItems.forEach((_, index) => {
    if (alreadyHasFoundActive) return;

    updatedItems[index].children = updateMenuItemActiveByStartOfUrl(updatedItems[index].children || []);

    const hasActiveChildren = !!(updatedItems[index].children || []).find((child) => child.active);

    const itemUrl = updatedItems[index].url || '~~~';
    updatedItems[index].active = hasActiveChildren || (
      itemUrl !== `${window.location.origin}/`.trim()
        && currentUrl.value.startsWith(itemUrl)
    );

    alreadyHasFoundActive = !!updatedItems[index].active;
  });

  return updatedItems;
};

const updateMenuItems = () => {
  menuDepthCheck.value = 0;
  let updatedMenuItems = [...(menuItemsStore.value || [])].map(isMenuItemRecursive);
  const hasActiveMenuItem = !!updatedMenuItems.find((item) => item.active);

  if (!hasActiveMenuItem) {
    updatedMenuItems = updateMenuItemActiveByStartOfUrl(updatedMenuItems);
  }

  if (JSON.stringify(updatedMenuItems) === JSON.stringify(menuItems.value)) return;

  menuItems.value = updatedMenuItems;

  if (menuDepth.value !== menuDepthCheck.value) {
    menuDepth.value = menuDepthCheck.value;
  }

  if (menuDepth.value >= 3) {
    const menuItemsTopNew = menuItems.value.map((menuItem) => {
      const menuItemTop = { ...menuItem };
      delete menuItemTop.children;

      return menuItemTop;
    });
    if (JSON.stringify(menuItemsTop.value) !== JSON.stringify(menuItemsTopNew)) {
      menuItemsTop.value = menuItemsTopNew;
    }

    const menuItemsMainNew = (menuItems.value.find((menuItem) => menuItem.active) || menuItems.value[0])?.children || [];
    if (JSON.stringify(menuItemsMain.value) !== JSON.stringify(menuItemsMainNew)) {
      menuItemsMain.value = menuItemsMainNew;
    }
  } else {
    menuItemsTop.value = [];
    if (JSON.stringify(menuItems.value) !== JSON.stringify(menuItemsMain.value)) {
      menuItemsMain.value = menuItems.value;
    }
  }

  nextTick(checkIfMobile);
};

watch(() => ({
  page: currentUrl.value,
  menu: menuItemsStore.value,
}), updateMenuItems, {
  deep: true,
  immediate: true,
});

onBeforeMount(() => {
  store.dispatch('menus/fetchBySlug', 'header');
});

onMounted(() => {
  header.$el = document.querySelector('header');
  window.addEventListener('scroll', setHeaderTop);
  window.addEventListener('resize', checkIfMobile);
  window.addEventListener('load', checkIfMobile);
  window.addEventListener('resize', setHeaderPos);
  window.addEventListener('load', setHeaderPos);
  setHeaderTop();
  checkIfMobile();
  setHeaderPos();
  for (let i = 100; i < 1000; i += 100) {
    setTimeout(setHeaderTop, i);
    setTimeout(setHeaderPos, i);
  }
});

onBeforeUnmount(() => {
  window.addEventListener('scroll', setHeaderTop);
  window.removeEventListener('resize', checkIfMobile);
  window.removeEventListener('load', checkIfMobile);
  window.removeEventListener('resize', setHeaderPos);
  window.removeEventListener('load', setHeaderPos);
});

const cartEnabled = env('CART_ENABLED', false);
const toggleCart = () => store.commit('cart/TOGGLE_SHOW_WIDGET');
const toggleSearch = () => {
  store.dispatch('search/toggle');
};

watch(() => isMobile.value, () => {
  store.dispatch('sidebar/close');
});

return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      ref_key: "root",
      ref: root,
      style: _normalizeStyle(`top:${header.top}px`),
      class: _normalizeClass(["d-print-none", {
        'slide-up': hideHeader.value,
        'desktop': isDesktop.value,
        'mobil': isMobile.value,
      }])
    }, [
      (menuItemsTop.value.length)
        ? (_openBlock(), _createBlock(HeaderTop, {
            key: 0,
            items: menuItemsTop.value
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "logoBar",
            ref: logoBar,
            class: _normalizeClass(["row brand-row g-0 d-desktop-block", { 'justify-content-end': isDesktop.value }])
          }, [
            (partner.value && partnerActive.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (partner.value.url)
                    ? (_openBlock(), _createBlock(_component_IoRouterLink, {
                        key: 0,
                        "link-url": partner.value.url,
                        "link-target": "_blank",
                        class: "brand-image-link partner"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: partner.value.thumbnail,
                            title: partner.value.title
                          }, null, 8, _hoisted_4)
                        ]),
                        _: 1
                      }, 8, ["link-url"]))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        innerHTML: partner.value.thumbnail,
                        title: partner.value.title
                      }, null, 8, _hoisted_5))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_IoRouterLink, {
                "link-url": "/",
                class: "brand-image-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _unref(logoSrc),
                    alt: "",
                    loading: "lazy"
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              })
            ])
          ], 2),
          _createElementVNode("div", {
            ref_key: "navBar",
            ref: navBar,
            class: "d-flex navbar-nav align-items-center text-center col"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(HeaderMain, { items: menuItemsMain.value }, null, 8, ["items"])
            ]),
            _createElementVNode("a", {
              class: "nav-link nav-link__other",
              href: _unref(customerPortalUrl),
              title: "Zum Kundencenter",
              target: "_blank"
            }, [
              _createVNode(_component_FontAwesomeIcon, { icon: "fa-light fa-circle-user" }),
              _hoisted_10
            ], 8, _hoisted_9),
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link nav-link__other", { 'last': isDesktop.value && !_unref(cartEnabled) }]),
              title: "Suche öffnen",
              href: "/suche/",
              onClick: _withModifiers(toggleSearch, ["prevent"])
            }, [
              _createVNode(_component_FontAwesomeIcon, { icon: "fa-light fa-search" }),
              _hoisted_11
            ], 2),
            (_unref(cartEnabled))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["nav-link nav-link__other", { 'last': isDesktop.value && _unref(cartEnabled) }]),
                  href: "/warenkorb/",
                  title: "Warenkorb öffnen",
                  onClick: _withModifiers(toggleCart, ["prevent"])
                }, [
                  _createVNode(IconCart),
                  _hoisted_12
                ], 2))
              : _createCommentVNode("", true)
          ], 512)
        ])
      ]),
      _createVNode(PageBanner)
    ], 6),
    (!isMobile.value)
      ? (_openBlock(), _createBlock(BaseFixedAside, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(IoSearchForm),
    _createVNode(IoSidebar, { items: menuItems.value }, null, 8, ["items"]),
    _createVNode(CartWidget),
    (isMobile.value)
      ? (_openBlock(), _createBlock(MobileNavigation, { key: 1 }))
      : _createCommentVNode("", true),
    (isMobile.value)
      ? (_openBlock(), _createBlock(ScrollTopButton, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})